import { cloneDeep } from 'lodash';
import useVuelidate from '@vuelidate/core';
import dayjs from 'dayjs';
import {
  DEFAULT_PER_PAGE,
  FIRST_PAGE,
  PER_PAGE_OPTIONS,
  WEEKDAYS,
} from '@/utils/constants';

const TAB_TYPES = {
  CREATED: 'created',
  PENDING: 'pending',
};

const BUYING_STATUS = {
  ONGOING: 0,
  ENDED: 1,
  FINISHED: 2,
  CANCELED: 3,
  SCHEDULED: 4,
};

export default {
  name: 'ScheduleOrderList',
  components: {
  },
  props: {
    created: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pending: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      activeTab: TAB_TYPES.PENDING,
      currentPage: FIRST_PAGE,
      exclude: [],
      perPage: DEFAULT_PER_PAGE,
      sortField: 'create',
      sortOrder: 'desc',
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.exclude = cloneDeep(newVal);
      },
      immediate: true,
      deep: true,
    },
    pendingList: {
      handler(newVal) {
        this.$emit('pending-list', newVal);
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    currentPageFirstIndex() {
      return (this.currentPage - 1) * this.perPage;
    },
    pendingListPerPage() {
      return this.pendingList
        .slice(this.currentPageFirstIndex, this.currentPageFirstIndex + this.perPage);
    },
    createdListPerPage() {
      return this.createdList
        .slice(this.currentPageFirstIndex, this.currentPageFirstIndex + this.perPage);
    },
    pendingList() {
      return this.pending
        .filter(({ groupBuyingStartTime: startTime, groupBuyingReceiveTimes: receiveTimes }) => {
          const isExclude = this.exclude
            .some((excludeTime) => {
              const start = dayjs(receiveTimes?.[0]?.[0]).format('YYYY-MM-DD');
              return excludeTime === start;
            });
          return dayjs().isBefore(dayjs(startTime)) && !isExclude;
        })
        .map(({
          groupBuyingStartTime, groupBuyingEndTime, groupBuyingReceiveTimes, groupBuyingCreateTime,
        }) => {
          const receiveTimes = groupBuyingReceiveTimes.map((times) => ({
            start_time: times[0],
            end_time: times[1],
          }));
          return {
            created_at: groupBuyingCreateTime,
            start_time: groupBuyingStartTime,
            end_time: groupBuyingEndTime,
            receive_times: receiveTimes,
          };
        })
        .sort((a, b) => {
          const aCreatedTime = dayjs(a.created_at);
          const bCreatedTime = dayjs(b.created_at);
          if (this.sortOrder === 'desc') {
            return bCreatedTime.isAfter(aCreatedTime) ? 1 : -1;
          }
          return aCreatedTime.isAfter(bCreatedTime) ? 1 : -1;
        });
    },
    createdList() {
      return this.created
        .map(({
          createdAt, endTime, startTime, buyingStatus, receiveTime, ...param
        }) => {
          const receiveTimes = receiveTime.map((time) => ({
            start_time: time.startTime,
            end_time: time.endTime,
          }));
          return {
            created_at: dayjs(createdAt),
            end_time: endTime,
            start_time: startTime,
            status: buyingStatus,
            receive_times: receiveTimes,
            ...param,
          };
        }).sort((a, b) => {
          const aCreatedTime = dayjs(a.created_at);
          const bCreatedTime = dayjs(b.created_at);
          if (this.sortOrder === 'desc') {
            return bCreatedTime.isAfter(aCreatedTime) ? 1 : -1;
          }
          return aCreatedTime.isAfter(bCreatedTime) ? 1 : -1;
        });
    },
    perPageOptions() {
      return PER_PAGE_OPTIONS;
    },
    TAB_TYPES() {
      return TAB_TYPES;
    },
    weekdayOptions() {
      return Array.from(
        { length: WEEKDAYS.length },
        (_, i) => {
          const key = (i + 1) % 7;
          return { label: WEEKDAYS[key], value: key };
        },
      );
    },
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format('YYYY/MM/DD');
    },
    getStatusText(status) {
      const text = {
        [BUYING_STATUS.ONGOING]: '開放訂購中',
        [BUYING_STATUS.ENDED]: '已截止訂購',
        [BUYING_STATUS.FINISHED]: '已完成',
        [BUYING_STATUS.CANCELED]: '已取消',
        [BUYING_STATUS.SCHEDULED]: '已公告',
      };
      return text[status] || '';
    },
    getStatusClass(status) {
      const statusClass = {
        [BUYING_STATUS.ONGOING]: 'text-blue-500',
        [BUYING_STATUS.ENDED]: 'text-black',
        [BUYING_STATUS.FINISHED]: 'text-black',
        [BUYING_STATUS.CANCELED]: 'text-gray-500',
        [BUYING_STATUS.SCHEDULED]: 'text-seaweed-green-500',
      };
      return statusClass[status] || '';
    },
    extraReceiveTimes(times = []) {
      const newArr = cloneDeep(times);
      newArr.shift();
      return newArr;
    },
    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
    },
    onScheduleDelete(receiveTimes) {
      if (!receiveTimes[0]?.start_time) {
        return;
      }
      this.exclude.push(receiveTimes[0]?.start_time?.format('YYYY-MM-DD'));
      this.$emit('input', this.exclude);
    },
  },
};
